import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetProductTypes, GetProductTypesResponse } from '../../apis/lookup';

interface RootState {
  ProductTypes: ProductTypeState;
}

export interface ProductTypeState {
  productTypeList: unknown[];
  status: string | number | null;
  is_success: boolean;
  hasFetched: boolean;
}

interface ProductTypeRejectedPayload {
  is_success?: boolean;
  status?: number;
  message?: string;
}

export const fetchAllProductTypes = createAsyncThunk<
  GetProductTypesResponse['data']['data'],
  string,
  { rejectValue: ProductTypeRejectedPayload }
>('productTypes/GetAllProductTypes', async (token: string, thunkAPI) => {
  try {
    const response = await GetProductTypes(token);
    const data = response?.data ? response?.data : null;
    if (data) {
      if (data?.data?.is_success) {
        return data?.data ? data?.data : null;
      } else {
        return thunkAPI.rejectWithValue(data?.data);
      }
    } else {
      // Reject with a generic message if the data is null or undefined
      return thunkAPI.rejectWithValue({ message: 'Unknown error occured' });
    }
  } catch (error) {
    return thunkAPI.rejectWithValue({
      message: error instanceof Error ? error.message : 'Request failed',
    });
  }
});

const productTypeSlice = createSlice({
  name: 'ProductTypes',

  initialState: {
    productTypeList: [],
    status: null,
    is_success: true,
    hasFetched: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllProductTypes.pending, (state) => {
        state.status = 'loading';
        state.hasFetched = true;
      })
      .addCase(fetchAllProductTypes.fulfilled, (state, action) => {
        state.status = action?.payload?.status;
        state.productTypeList = Array.isArray(action?.payload?.data)
          ? action.payload.data
          : [];
        state.is_success = action?.payload?.is_success; // Populate state with fetched data
      })
      .addCase(fetchAllProductTypes.rejected, (state, action) => {
        state.is_success = action?.payload?.is_success || false;
        state.status = action?.payload?.status || 'Unknown error occured';
        state.productTypeList = [];
        state.hasFetched = false;
      });
  },
});

//selector ref to get the state
export const selectProductTypeState = (state: RootState): ProductTypeState =>
  state.ProductTypes;

export const productTypeReducer = productTypeSlice.reducer;
